import api from "../service/api";

// 🔹 Send OTP
export const sendOtpApi = (data) => {
  return api.post("/forgot/send-otp", data);
};

// 🔹 Verify OTP
export const verifyOtpApi = (data) => {
  return api.post("/forgot/verify-otp", data);
};

// 🔹 Reset Password
export const resetPasswordApi = (data) => {
  return api.post("/forgot/reset-password", data);
};

api.interceptors.response.use(
  (response) => response,

  (error) => {
    console.log("API ERROR:", error.response);

    // ❌ No redirect
    // ❌ No window.location.href
    // ❌ No navigate

    return Promise.reject(error);
  }
);